import React, { useState } from "react";
import {
  Menu, MenuButton, MenuList, MenuItem, Button, HStack, Text, Image, 
  Box, Flex, Input, VStack, Divider, IconButton,
} from "@chakra-ui/react";
import { RepeatIcon, ChevronDownIcon } from "@chakra-ui/icons";


const currencyData = {
  CAD: { label: "Canadian Dollar", flag: "/flags/ca.png" },
  NGN: { label: "Nigerian Naira", flag: "/flags/ng.png" },
  /*USD: { label: "US Dollar", flag: "/flags/us.png" },
  GBP: { label: "British Pound", flag: "/flags/gb.png" },
  EUR: { label: "Euro", flag: "/flags/eu.png" },*/
};

// Base rates in USD for dynamic conversion
const baseRates = {
  USD: 1,
  CAD: 1.36,
  NGN: 1442,
  GBP: 0.73,
  EUR: 0.84,
};
                                          



export const ConversionBox = ({ defaultToCurrency = "NGN", onToCurrencyChange, ...props }) => {
  const [fromCurrency, setFromCurrency] = useState("CAD");
  const [toCurrency, setToCurrency] = useState(defaultToCurrency);
  const [amount, setAmount] = useState(100);

  const rate = baseRates[toCurrency] / baseRates[fromCurrency];
  const fee = 0;

  const parsedAmount = Number(amount);
  const converted = parsedAmount * rate;
  const totalToPay = parsedAmount + fee;

  const swapCurrencies = () => {
    setFromCurrency(toCurrency);
    setToCurrency(fromCurrency);
  };

  React.useEffect(() => {
    if (onToCurrencyChange) {
      onToCurrencyChange(toCurrency);
    }
  }, [onToCurrencyChange, toCurrency]);

  const Flag = ({ code }) => ( 
    <Box
      width="28px"
      height="20px"
      minW="28px"
      minH="20px"
      overflow="hidden"
      borderRadius="md"
      display="inline-flex"
      flexShrink={0}
    > 
        <Image
          src={currencyData[code].flag}
          width="100%"
          height="100%"
          objectFit="cover"
          display="block"
        /> 
    </Box> 
    );
  
  const CurrencySelector = ({ value, onChange, }) => ( 
    <Menu> 
           <MenuButton as={Button} rightIcon={<ChevronDownIcon />}  borderRadius="full" 
             bg="white" border="1px solid #ddd" px={2} display="flex" 
             justifyContent="space-between"
             w={{ base: "auto", md: "35%" }}
             minW={{ base: "120px", sm: "140px", md: "0" }}
             _hover={{ bg: "blue.50" }} _active={{ bg: "blue.50" }}
             > 
            <HStack spacing={2} align="center" flexShrink={0}> 
                <Flag code={value} /> <Text fontWeight="bold" fontSize={14}>{value}</Text> 
            </HStack> 
        </MenuButton>
          <MenuList w= {{ base: "130%", md: "110%" }} minW="auto" border="none" borderRadius="lg" boxShadow="md" maxH="150px" overflowY="auto"> 
            {Object.keys(currencyData).map((code) => ( 
                <MenuItem key={code} onClick={() => onChange(code)} _hover={{ bg: "blue.50" }}> 
                  <HStack spacing={2} align="center"> 
                        <Flag code={code} /> 
                        <Text fontWeight="bold" fontSize={14} color="gray.700">{code}</Text> 
                    </HStack> 
                </MenuItem> ))} 
        </MenuList> 
    </Menu> );

  const boxBg = "gray.50";
  const inputBg = "white";
  const textColor = "gray.600";
  const textColorDark = "gray.700";

  return (
    <Box
      {...props}
      borderRadius="3xl"
      border="2px solid"
      borderColor="gray.200"
      boxShadow="0 22px 60px rgba(15, 14, 14, 0.2)"
      p={3}
      maxW="480px"
      w="100%"
      mb = {{ base: -8, md: 2, lg: 2 }}
      
     
    >
      <VStack align="stretch" spacing={{ base: 0, md: 2, lg: 2 }} >
        <Text fontSize={16} fontWeight="bold" color={textColorDark} textAlign="center" 
            py={2} >
          Best Rates Guaranteed!
        </Text>

        {/* You Send */}
        <Box >
          <Flex
            bg ={inputBg}
            border="2px solid"
            borderColor="gray.300"
            borderRadius="full"
            p={2}
            align="center"
            gap={3}
            position="relative"
            flexDirection="column"
            alignItems="flex-start"
          >
            <Text fontSize={14} color={textColorDark} position="absolute" top="0" left="6" >
              You send
            </Text>
            
            <Flex w="100%" align="center" gap={3} mt="3">
              <Input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                color= "gray.700"
                fontSize={{ base: "xl", sm: "2xl" }}
                fontWeight="bold"
                border="none"
                _focus={{ boxShadow: "none" }}
              />

              <CurrencySelector value={fromCurrency} onChange={setFromCurrency} />
            </Flex>
          </Flex>
        </Box>

        {/* Swap Button */}
        <Flex justify="center">
          <IconButton
            aria-label="swap"
            icon={<RepeatIcon />}
            onClick={swapCurrencies}
            borderRadius="full"
            size="md"
            bg={boxBg}
          />
        </Flex>

        {/* Recipient Gets */}
        <Box>
           <Flex
            bg ={inputBg}
            border="2px solid"
            borderColor="gray.300"
            borderRadius="full"
            p={2}
            align="center"
            gap={3}
            position="relative"
            flexDirection="column"
            alignItems="flex-start"
           >
                <Text fontSize={14} color={textColorDark} position="absolute" top="0" left="6">
                Recipient gets
                </Text>

                <Flex w="100%" align="center" gap={3} mt="3" >
                      <Input
                        isReadOnly
                        value={parseFloat(converted.toFixed(2))}
                        fontSize={{ base: "xl", sm: "2xl" }}
                        fontWeight="bold"
                        color="gray.700"
                        border="none"
                        _focus={{ boxShadow: "none" }}
                    />
                    <CurrencySelector value={toCurrency} onChange={setToCurrency} />
                </Flex>
            </Flex>
        </Box>

        {/* Rate + Fee */}
        <Box fontSize={14} color={textColor} py={3}>
          <Text>
            Rate: 1 {fromCurrency} ≈ {rate.toFixed(2)} {toCurrency}
          </Text>
          <Text>Transfer fee: {fee.toFixed(2)} {fromCurrency}</Text>
        </Box>

        <Divider borderColor="gray.600" />

        {/* Total */}
        <HStack  py={3}>
          <Text fontSize={14} color={textColor}>
            Total to pay:
          </Text>
          <Text fontWeight="bold" fontSize="lg" color={textColorDark}>
            {totalToPay.toFixed(2)} {fromCurrency}
          </Text>
        </HStack>

        <Button
            as="a" 
            href="#download-section" 
            bg="rgb(20, 20, 20)"
            color="white"
            fontWeight="bold"
            size="lg"
            borderRadius="full"
            px={10}
            _hover={{ bg: "rgb(10, 10, 10)", transform: "scale(1.05)" }}
            transition="all 0.2s"
          >
            Get this rate
          </Button>
      </VStack>
    </Box>
  );
};
